
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.857 4.311a2.286 2.286 0 012.286-2.286h9.143a2.286 2.286 0 012.286 2.286V15.74a2.286 2.286 0 002.285 2.285H3.143A2.286 2.286 0 01.857 15.74V4.31zm3.429 1.143h6.857v4.571H4.286V5.454zm6.857 6.857H4.286v2.286h6.857V12.31z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.714 6.597h1.143a2.286 2.286 0 012.286 2.286v6.285a1.714 1.714 0 11-3.429 0V6.597z","fill":"#fff"}})])
          )
        }
      }
    